module.exports = __webpack_public_path__ + "static/media/landing-background-old.a18565e4.jpg";